import groupHeaderCommandBarAction from "owa-group-header-store/lib/actions/commandBarAction";
import groupHeaderNavigationButton from "owa-group-header-store/lib/store/schema/NavigationButton";
import type { MailGroupRouteParameters } from "./utils/mailGroupRouteSettings";
import { ensureValidGroupSmtpAddress } from "./utils/mailGroupRouteSettings";
import { logUsage } from "owa-analytics";
import { getSourceQueryParam } from "owa-querystring";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { lazySwitchToGroupsModule } from "owa-groups-dash-nav-actions/lib/lazyCalendarBoot";
import { lazyLoadGroupsList } from "owa-groups-left-nav-actions/lib/lazyFunction";
import GroupsDashTabId from "owa-groups-dash-content-store/lib/store/schema/GroupsDashTabId";
import { isConsumer } from "owa-session-store";
import mailGroupRouteHandler from "./mailGroupRouteHandler";

export default async function mailGroupFilesRouteHandler(parameters: MailGroupRouteParameters): Promise<void> {
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    if (isConsumer(undefined, mailboxInfo)) {
        // Group Files view in Consumer accounts is deprecated, redirect to Email view
        mailGroupRouteHandler(parameters);
        return;
    }
    const groupSmtp = ensureValidGroupSmtpAddress(parameters);
    
    if (!groupSmtp) {
        return;
    }
    
    logUsage("MailGroupFilesRouteHandlerEvent", mailboxInfo, { source: getSourceQueryParam() });
    
    groupHeaderCommandBarAction(groupHeaderNavigationButton.Files);
    
    const loadGroupsList = await lazyLoadGroupsList.import();
    await loadGroupsList(mailboxInfo, false /*isReload*/, true /*SubscribeAll */);
    lazySwitchToGroupsModule.importAndExecute(mailboxInfo, groupSmtp, undefined /*folderId*/, GroupsDashTabId.Files, "MailAppGroupsFilesRouting");
}
